





















































































































































































































































import Vue from 'vue'
import VueRouter from 'vue-router'
import postAppMessage, { MessageHandlers } from '@/utils/poster'
import { HeaderMap } from '@/constants/personalBook'
import { MetaInfo } from 'vue-meta/types/vue-meta'

export default Vue.extend({
  name: 'PersonalBook',
  data () {
    return {
      hasError: false,
      isLoading: false,
      isEnableValidation: false,
      bookInfo: {
        name: '' as string,
        faceType: 0,
        traitSelected: '00000000',
        materialSelected: 0,
        cover: 2,
        backgroundSelected: 0,
        message: '' as string,
        imagePath: '' as string
      },
      traitItems: [
        '勇敢', '誠實', '健康', '善良', '感恩', '聰明', '樂觀', '勤奮'
      ],
      materialOptions: [ // product_model
        { value: '精裝-銅版紙　　　', price: '$599', del_price: '$699' },
        { value: '精裝-高彩度相紙　', price: '$699', del_price: '$799' },
        { value: '平裝-銅版紙　　　', price: '$449', del_price: '$549' }
      ],
      backgroundOptions: [
        'https://nuphoto.com.tw/personalbook/assets/background_0.jpg',
        'https://nuphoto.com.tw/personalbook/assets/background_1.jpg',
        'https://nuphoto.com.tw/personalbook/assets/background_2.jpg',
        'https://nuphoto.com.tw/personalbook/assets/background_3.jpg'
      ],
      backgroundCarouselImage: [
        'https://nuphoto.com.tw/personalbook/assets/background_img_0.jpg',
        'https://nuphoto.com.tw/personalbook/assets/background_img_1.jpg',
        'https://nuphoto.com.tw/personalbook/assets/background_img_2.jpg',
        'https://nuphoto.com.tw/personalbook/assets/background_img_3.jpg'
      ]
    }
  },
  metaInfo (): MetaInfo {
    return {
      title: '角色設定',
      titleTemplate: '%s | nuPhoto 拍立洗'
    }
  },
  computed: {
    screenAspectRatio (): number {
      return window.screen.width / window.screen.height
    },
    traitSelectedCount (): number {
      let num = 0
      for (const item of this.bookInfo.traitSelected) {
        if (item === '1') {
          num++
        }
      }
      return num
    }
  },
  created () {
    postAppMessage(MessageHandlers.UPDATE_HEADER, HeaderMap.PERSONALBOOK)
    this.loadBookInfoFromLocalStorage()
  },
  methods: {
    validateName (target: string | number | null | undefined) {
      if (this.isEnableValidation) {
        if (target === null || target === undefined) {
          this.hasError = true
          return false
        }
        // Chinese+English+Number+_ : [1,8] / except Chinese: [1,12]
        if (typeof (target) === 'string' && (!target.match(/^[\u44a9\u4507\u4E00-\u9FA5a-zA-Z0-9_]{1,8}$/) && !target.match(/^[a-zA-Z0-9_]{1,12}$/))) {
          this.hasError = true
          return false
        }
        return true
      }
      return null
    },
    validateTrait () {
      if (this.isEnableValidation) {
        if (this.traitSelectedCount !== 4) {
          this.hasError = true
          return false
        }
        return true
      }
      return null
    },
    onFaceImageClicked (index: number) {
      if (index < 0) return
      this.bookInfo.faceType = index
      this.saveBookInfoToLocalStorage()
    },
    onTraitItemClicked (index: number) {
      const prefix = this.bookInfo.traitSelected.substring(0, index)
      const suffix = this.bookInfo.traitSelected.substring(index + 1, 8)
      let c = this.bookInfo.traitSelected.charAt(index)
      c = (c === '1') ? '0' : '1'
      this.bookInfo.traitSelected = prefix + c + suffix
      this.saveBookInfoToLocalStorage()
    },
    onMaterialItemClicked (index: number) {
      this.bookInfo.materialSelected = index
      this.saveBookInfoToLocalStorage()
    },
    saveBookInfoToLocalStorage () {
      localStorage.setItem('bookInfo', JSON.stringify({
        name: this.bookInfo.name,
        faceType: this.bookInfo.faceType || 0,
        traitSelected: this.bookInfo.traitSelected,
        materialSelected: this.bookInfo.materialSelected || 0,
        cover: this.bookInfo.cover === undefined ? 2 : this.bookInfo.cover,
        backgroundSelected: this.bookInfo.backgroundSelected || 0,
        message: this.bookInfo.message,
        imagePath: this.bookInfo.imagePath
      }))
    },
    loadBookInfoFromLocalStorage () {
      const dataString = localStorage.getItem('bookInfo') || ''
      if (dataString) {
        const data = JSON.parse(dataString)
        this.bookInfo.name = data.name
        this.bookInfo.faceType = data.faceType
        this.bookInfo.traitSelected = data.traitSelected
        this.bookInfo.materialSelected = data.materialSelected
        this.bookInfo.cover = data.cover
        this.bookInfo.backgroundSelected = data.backgroundSelected
        this.bookInfo.message = data.message
        this.bookInfo.imagePath = data.imagePath
      }
    },
    async onNextClicked () {
      this.isLoading = true
      this.saveBookInfoToLocalStorage()
      this.isEnableValidation = true

      // Invoke in next tick to wait for isEnableValidation change and all input states change
      this.$nextTick(async () => {
        let validationOverall = true // The result of all validations clear
        const errorStack = []

        // Validate name
        if (!(this.validateName(this.bookInfo.name))) {
          errorStack.push('暱稱填寫錯誤。')
          validationOverall = false
        }

        // Validate faceType
        if (!(this.validateTrait())) {
          errorStack.push('請選擇4項特質。')
          validationOverall = false
        }

        // Collect error messages and show them once
        const messageVNode = []
        for (const e of errorStack) {
          messageVNode.push(this.$createElement('p', { class: ['text-center', 'mt-2', 'mb-0'] }, e))
        }

        // Show the message if validation failed then return
        if (validationOverall === false) {
          this.isLoading = false
          this.$bvModal.msgBoxOk(messageVNode, {
            centered: true,
            footerClass: 'msgbox-ok-footer',
            okTitle: '確定'
          })
          return
        }
        this.prepareCover()
      })
    },
    prepareCover () {
      const pre = [
        'https://nuphoto.com.tw/personalbook/assets/cover_option0_' + this.bookInfo.faceType + '.jpg',
        'https://nuphoto.com.tw/personalbook/assets/cover_option1_' + this.bookInfo.faceType + '.jpg',
        'https://nuphoto.com.tw/personalbook/assets/cover_option2_' + this.bookInfo.faceType + '.jpg',
        'https://nuphoto.com.tw/personalbook/assets/cover_option3_' + this.bookInfo.faceType + '.jpg',
        'https://nuphoto.com.tw/personalbook/assets/preview/cover_pre0_' + this.bookInfo.faceType + '.jpg',
        'https://nuphoto.com.tw/personalbook/assets/preview/cover_pre1_' + this.bookInfo.faceType + '.jpg',
        'https://nuphoto.com.tw/personalbook/assets/preview/cover_pre2_' + this.bookInfo.faceType + '.jpg',
        'https://nuphoto.com.tw/personalbook/assets/preview/cover_pre3_' + this.bookInfo.faceType + '.jpg'
      ]

      const imageContainer = document.getElementById('image-container')
      for (const i in pre) {
        let preImg = document.getElementById('pb-img' + i) as HTMLImageElement
        if (!preImg) {
          console.log('createElement')
          preImg = document.createElement('img')
          preImg.id = 'pb-img' + i
          if (imageContainer) {
            imageContainer.appendChild(preImg)
          }
        }
        preImg.src = pre[i]
      }

      setTimeout(() => {
        for (const i in pre) {
          const preImg = document.getElementById('pb-img' + i) as HTMLImageElement
          if (preImg) {
            if (!preImg.complete) {
              this.prepareCover()
              return
            }
          }
        }

        if (imageContainer) {
          imageContainer.innerHTML = ''
        }
        this.$router.push({ name: 'PersonalBookCover', query: this.$route.query }).catch(error => {
          if (!VueRouter.isNavigationFailure(error, VueRouter.NavigationFailureType.redirected)) {
            this.$bvModal.msgBoxConfirm(`${error.message}是否要再次嘗試？`, {
              centered: true,
              noCloseOnBackdrop: true,
              noCloseOnEsc: true,
              footerClass: 'msgbox-confirm-footer',
              cancelTitle: '否',
              okTitle: '是'
            }).then((result) => {
              if (result) this.prepareCover()
            })
          }
        })

        this.isEnableValidation = false
        this.isLoading = false
      }, 250)
    }
  }
})
